/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Resolve pending transfer DTO.
 */
export interface GoldenTransferResolveDto {
  transferId: number;
  skipTransfer: boolean;
  /**
   * required if transfer will be skipped
   */
  skipComment?: string;
  /**
   * required if skipTransfer = false.
   */
  reviewIndividually?: boolean;
  /**
   * required if skipTransfer = false.
   */
  accountId?: number;
  /**
   * Optional in process individual case.
   */
  exchangeWithdrawalFee?: number;
}
